import { render, staticRenderFns } from "./buyorderlist.vue?vue&type=template&id=2f8ed6fc&scoped=true&"
import script from "./buyorderlist.vue?vue&type=script&lang=js&"
export * from "./buyorderlist.vue?vue&type=script&lang=js&"
import style0 from "./buyorderlist.vue?vue&type=style&index=0&id=2f8ed6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ed6fc",
  null
  
)

export default component.exports